"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconLinks = exports.getSecondaryLinks = exports.getPrimaryLinks = void 0;
const urlHelpers = __importStar(require("./urls"));
const camelize_1 = require("./camelize");
const removeNamespace_1 = __importDefault(require("./removeNamespace"));
const linkOption_1 = require("../../types/linkOption");
const getLegalURLTranslation = (item, i18n) => (0, removeNamespace_1.default)(item) === 'copyright'
    ? `${new Date().getFullYear()} © Babbel GmbH`
    : i18n(`${item}.title`);
const getPrimaryLinks = (dataConfig) => {
    const { i18n } = dataConfig;
    return Object.values(linkOption_1.PrimaryLinkName).map((item) => {
        const functionName = `${(0, camelize_1.camelize)(item)}URL`;
        return ({
            href: urlHelpers[functionName](dataConfig),
            id: item,
            title: i18n(`${item}.title`)
        });
    });
};
exports.getPrimaryLinks = getPrimaryLinks;
const getSecondaryLinks = (dataConfig) => {
    const { i18n } = dataConfig;
    return Object.values(linkOption_1.SecondaryLinkName).map((linkName) => {
        const linkNameWithoutNamespace = (0, removeNamespace_1.default)(linkName);
        const builtUrl = linkNameWithoutNamespace === 'cancel_subscription'
            ? urlHelpers.cancelSubscriptionURL(dataConfig)
            : urlHelpers.legalURL(dataConfig, linkName);
        return {
            href: builtUrl,
            id: linkNameWithoutNamespace,
            title: getLegalURLTranslation(linkName, i18n)
        };
    });
};
exports.getSecondaryLinks = getSecondaryLinks;
const getIconLinks = (dataConfig) => {
    const { i18n } = dataConfig;
    return Object.values(linkOption_1.IconLinkName).map((item) => {
        const functionName = `${(0, camelize_1.camelize)(item)}URL`;
        return {
            href: urlHelpers[functionName](dataConfig),
            id: (0, removeNamespace_1.default)(item, 'social'),
            title: i18n(`${item}.title`)
        };
    });
};
exports.getIconLinks = getIconLinks;
//# sourceMappingURL=index.js.map